import { AlignTypes } from "@monorepo-web/components-library";
export const getLayouts = () => ({
    'default': [
        {
            id: 'mesano',
            label: 'Mês/Ano',
        },
        {
            id: 'saldoMovim',
            label: 'Saldo Movimentações',
            align: AlignTypes.right,
        },
        {
            id: 'saldoBruto',
            label: 'Saldo Bruto',
            align: AlignTypes.right,
        },
    ]
});
